module.exports = __webpack_public_path__ + "static/media/ic_tooltip_visible.7cb4fbb9.svg";